import { IActivityLogResponse } from 'api/queries/activityLog.query';

import { AssigneeContentText } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/activityLog/contentText/textOptions/assigneeContentText';
import { DefaultContentText } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/activityLog/contentText/textOptions/defaultContentText';
import { LaneIdContentText } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/activityLog/contentText/textOptions/laneIdContentText';

export const ContentText = ({ log }: { log: IActivityLogResponse }) => {
    switch (log.fieldName) {
        case 'laneId':
            return (
                <LaneIdContentText
                    firstName={log.firstName}
                    lastName={log.lastName}
                    newValues={log.newValues}
                    oldValues={log.oldValues}
                />
            );
        case 'assignee':
            return (
                <AssigneeContentText
                    firstName={log.firstName}
                    lastName={log.lastName}
                    newValues={log.newValues}
                    oldValues={log.oldValues}
                />
            );
        default:
            return (
                <DefaultContentText
                    firstName={log.firstName}
                    lastName={log.lastName}
                    newValues={log.newValues}
                    oldValues={log.oldValues}
                    fieldName={log.fieldName}
                />
            );
    }
};
